/* LEAGUE OF DISTORTION — theme.js
   AJAX cart drawer, variant picker, sticky ATC, mobile nav, newsletter. */
(function(){
  "use strict";
  var CFG = window.theme || {};
  var money = CFG.moneyFormat || "${{amount}}";

  function formatMoney(cents){
    var v = (cents/100);
    function withComma(n){ return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.(\d{2})$/, ",$1"); }
    function withDot(n){ return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(v))
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(v).toString())
                .replace(/\{\{\s*amount\s*\}\}/g, withDot(v));
  }

  function $(s,c){ return (c||document).querySelector(s); }
  function $all(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  /* ---------- cart drawer ---------- */
  var overlay = $("#drawer-overlay");
  var drawer  = $("#cart-drawer");

  function openDrawer(){ if(overlay){overlay.classList.add("open");} if(drawer){drawer.classList.add("open");} document.body.classList.add("mobile-menu-open"); }
  function closeDrawer(){ if(overlay){overlay.classList.remove("open");} if(drawer){drawer.classList.remove("open");} document.body.classList.remove("mobile-menu-open"); }

  function renderCart(cart){
    var itemsEl = $("#drawer-items");
    var countEls = $all(".cart-count");
    countEls.forEach(function(el){ el.textContent = cart.item_count; el.setAttribute("data-count", cart.item_count); });
    if(!itemsEl) return;
    if(cart.item_count === 0){
      itemsEl.innerHTML = '<div class="drawer__empty">'+(CFG.str_empty||"Your cart is empty")+'</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(it){
        var opt = (it.options_with_values||[]).map(function(o){return o.value;}).join(" / ");
        return '<div class="dline" data-key="'+it.key+'">'+
          '<img src="'+(it.image? it.image.replace(/(\.[a-z]+)(\?.*)?$/,'_120x$1$2'):"" )+'" alt="">'+
          '<div><div class="dline__title">'+it.product_title+'</div>'+
          (opt?'<div class="dline__opt">'+opt+'</div>':'')+
          '<div class="dline__qty"><button data-act="dec" aria-label="minus">−</button>'+
          '<span>'+it.quantity+'</span><button data-act="inc" aria-label="plus">+</button></div></div>'+
          '<div><div class="dline__price">'+formatMoney(it.final_line_price)+'</div>'+
          '<button class="dline__remove" data-act="rm">'+(CFG.str_remove||"Remove")+'</button></div></div>';
      }).join("");
    }
    var sub = $("#drawer-subtotal"); if(sub) sub.textContent = formatMoney(cart.total_price);
    // free shipping bar
    var thr = CFG.freeShipThreshold||0;
    var bar = $("#ship-fill"), note = $("#ship-note");
    if(thr>0 && bar && note){
      var pct = Math.min(100, (cart.total_price/thr)*100);
      bar.style.width = pct+"%";
      if(cart.total_price >= thr){ note.innerHTML = (CFG.str_ship_ok||"You unlocked free shipping!"); }
      else { note.innerHTML = (CFG.str_ship_left||"{{amount}} away from free shipping").replace("{{amount}}", "<b>"+formatMoney(thr-cart.total_price)+"</b>"); }
    }
  }

  function fetchCart(){ return fetch(CFG.cartUrl||"/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}); }

  function addToCart(id, qty){
    return fetch(CFG.cartAddUrl||"/cart/add.js",{
      method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:[{id:id, quantity:qty||1}]})
    }).then(function(r){ return r.json(); });
  }
  function changeLine(key, qty){
    return fetch(CFG.cartChangeUrl||"/cart/change.js",{
      method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({id:key, quantity:qty})
    }).then(function(r){ return r.json(); });
  }

  // open cart button(s)
  $all("[data-open-cart]").forEach(function(b){ b.addEventListener("click", function(e){ e.preventDefault(); fetchCart().then(function(c){ renderCart(c); openDrawer(); }); }); });
  if(overlay) overlay.addEventListener("click", closeDrawer);
  $all("[data-close-cart]").forEach(function(b){ b.addEventListener("click", closeDrawer); });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape"){ closeDrawer(); closeMnav(); } });

  // line item qty / remove (event delegation)
  if(drawer) drawer.addEventListener("click", function(e){
    var btn = e.target.closest("[data-act]"); if(!btn) return;
    var line = e.target.closest(".dline"); if(!line) return;
    var key = line.getAttribute("data-key");
    var act = btn.getAttribute("data-act");
    var qtySpan = line.querySelector(".dline__qty span");
    var cur = qtySpan? parseInt(qtySpan.textContent,10):1;
    var next = act==="inc"?cur+1: act==="dec"?cur-1: act==="rm"?0:cur;
    if(next<0) next=0;
    changeLine(key, next).then(renderCart);
  });

  // add-to-cart buttons (grid quick-add + PDP)
  $all("[data-add-to-cart]").forEach(function(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if(!idInput || !idInput.value) return;
      var btn = form.querySelector('[type="submit"]');
      var label = btn? btn.textContent : "";
      if(btn){ btn.disabled = true; btn.textContent = CFG.str_adding||"Adding…"; }
      addToCart(idInput.value, qtyInput? parseInt(qtyInput.value,10):1).then(function(res){
        if(res.status){ // error
          if(btn){ btn.textContent = res.description||"Error"; }
        } else {
          fetchCart().then(function(c){ renderCart(c); openDrawer(); });
          if(btn){ btn.textContent = CFG.str_added||"Added ✓"; }
        }
        setTimeout(function(){ if(btn){ btn.disabled=false; btn.textContent=label; } }, 1200);
      });
    });
  });

  /* ---------- variant picker (PDP) ---------- */
  var pdp = $("#pdp-main");
  if(pdp){
    var dataEl = $("#product-json");
    var product = dataEl? JSON.parse(dataEl.textContent) : null;
    if(product){
      var idField = $("#pdp-variant-id");
      var priceEl = $("#pdp-price");
      var atcBtn  = $("#pdp-atc");
      var stickyPrice = $("#sticky-price");
      function currentSelection(){
        return $all(".pdp__opt").map(function(opt){
          var checked = opt.querySelector("input:checked");
          return checked? checked.value : null;
        });
      }
      function matchVariant(sel){
        return product.variants.find(function(v){
          return v.options.every(function(o,i){ return o === sel[i]; });
        });
      }
      function updateVariant(){
        var sel = currentSelection();
        var v = matchVariant(sel);
        // visual pill state
        $all(".pill").forEach(function(p){ var i=p.querySelector("input"); p.classList.toggle("checked", i && i.checked); });
        if(!v){ if(atcBtn){ atcBtn.disabled=true; atcBtn.textContent = CFG.str_unavailable||"Unavailable"; } return; }
        if(idField) idField.value = v.id;
        var html = "";
        if(v.compare_at_price > v.price){
          html = '<span class="now">'+formatMoney(v.price)+'</span><span class="was">'+formatMoney(v.compare_at_price)+'</span>';
        } else { html = formatMoney(v.price); }
        if(priceEl) priceEl.innerHTML = html;
        if(stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if(atcBtn){
          atcBtn.disabled = !v.available;
          atcBtn.textContent = v.available? (CFG.str_add||"Add to cart") : (CFG.str_soldout||"Sold out");
        }
      }
      $all(".pdp__opt input").forEach(function(i){ i.addEventListener("change", updateVariant); });
      updateVariant();

      // gallery thumbs
      $all(".pdp__thumbs img").forEach(function(t){
        t.addEventListener("click", function(){
          var main = $("#pdp-main-img"); if(main){ main.src = t.getAttribute("data-full")||t.src; }
          $all(".pdp__thumbs img").forEach(function(x){ x.classList.remove("active"); });
          t.classList.add("active");
        });
      });

      // sticky mobile ATC
      var sticky = $("#sticky-atc");
      if(sticky && atcBtn){
        var obs = new IntersectionObserver(function(entries){
          entries.forEach(function(en){ sticky.classList.toggle("show", !en.isIntersecting); });
        }, {threshold:0});
        obs.observe(atcBtn);
        var sBtn = $("#sticky-add");
        if(sBtn) sBtn.addEventListener("click", function(){ if(!atcBtn.disabled) atcBtn.click(); });
      }
    }
  }

  /* ---------- mobile nav ---------- */
  var mnav = $("#mobile-nav");
  function closeMnav(){ if(mnav){ mnav.classList.remove("open"); document.body.classList.remove("mobile-menu-open"); } }
  $all("[data-open-nav]").forEach(function(b){ b.addEventListener("click", function(){ if(mnav){ mnav.classList.add("open"); document.body.classList.add("mobile-menu-open"); } }); });
  $all("[data-close-nav]").forEach(function(b){ b.addEventListener("click", closeMnav); });

  /* ---------- init cart count on load ---------- */
  fetchCart().then(function(c){ renderCart(c); }).catch(function(){});
})();

